export default {
    orders: [],
    orderStatusList: [],
    ordersLoading: false,
    ordersForShippingLabels: [],
    ordersForShippingLabelsLoading: false,
    ecommerceOrdersFilters: setInitialEcommerceOrdersFilters(),
    setInitialEcommerceOrdersFilters: setInitialEcommerceOrdersFilters,
    internalOrdersFilters: setInitialInternalOrdersFilters(),
    setInitialInternalOrdersFilters: setInitialInternalOrdersFilters,
    nonStandardOrdersFilters: setInitialNonStandardOrdersFilters(),
    setInitialNonStandardOrdersFilters: setInitialNonStandardOrdersFilters
}

function setInitialInternalOrdersFilters() {
    return {
        status_id: '10,15', // Nowe, Zatwierdzone
        createdBy_id: null,
        plannedSendDate__gte: null,
        plannedSendDate__lte: null,
        productionNumber: null,
        orderKind_id: 20
    }
}

function setInitialEcommerceOrdersFilters() {
    return {
        productionNumber: null,
        plannedSendDate__gte: null,
        plannedSendDate__lte: null,
        orderKind_id: 10,
        status_id: '10,15'
    }
}

function setInitialNonStandardOrdersFilters() {
    return {
        orderKind_id: 30,
        productionNumber: null,
        plannedSendDate__gte: null,
        plannedSendDate__lte: null
    }
}